import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import "./style.css";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import { deleteData, getData, postData } from "../../../api/method";
import ModalDelete from "../../../components/admin/ModalConfirm";
import TableReview from "./table";
import CollapseReview from "./collapse";

const username = localStorage.getItem("username");

function Review(args) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const [openDel, setOpenDel] = useState(false);

  const toggleDel = () => setOpenDel(!openDel);

  const closeBtnDel = (
    <button className="close" onClick={toggleDel}>
      &times;
    </button>
  );

  const today = new Date(),
    getDate =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();

  const navigate = useNavigate();

  const [error, setError] = useState({});
  const [data, setData] = useState([]);
  const [review, setReview] = useState("");
  const [date, setDate] = useState(getDate);

  const validation = (e) => {
    const msg = {};

    if (review === "") {
      msg.review = "Review is requied!";
    }

    setError(msg);
    if (Object.keys(msg).length > 0) return false;
    return true;
  };

  const handleKeyUp = () => {
    validation();
  };

  const { id } = useParams();

  const getReview = async () => {
    try {
      const result = await getData(`/api/Review/list/${id}`);
      setData(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getReview();
  }, [data]);

  const handleSubmitReview = async () => {
    const isValid = validation();
    const formData = new FormData();

    if (isValid) {
      formData.append("userId", username);
      formData.append("productId", id);
      formData.append("date", date);
      formData.append("comment", review);

      try {
        const res = await postData("/api/Review", formData);
        if (res.status === 200) {
          setIsOpen(false);
          toast.success("Add success!");
          setReview("");
        }
      } catch (err) {
        console.log(err);
        setIsOpen(false);
        toast.error("Add fail!");
      }
    }
  };

  const [dataDel, setDataDel] = useState([]);

  const getReviewByDel = async (id) => {
    try {
      const result = await getData(`/api/Review/${id}`);
      setDataDel(result.data);
      setOpenDel(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitDel = async (id) => {
    try {
      const res = await deleteData(`/api/Review/${id}`);
      if (res.status === 200) {
        toast.success("Delete success!");
        setOpenDel(false);
      }
    } catch (err) {
      console.log(err);
      toast.error("Delete fail!");
      setOpenDel(false);
    }
  };

  return (
    <div>
      <div>
        <div className="d-flex justify-content-end">
          <Button className="btn_review" onClick={toggle}>
            Write a review
          </Button>
        </div>

        <CollapseReview
          onChange={(e) => setReview(e.target.value)}
          onKeyUp={handleKeyUp}
          onClick={() => handleSubmitReview()}
          isOpen={isOpen}
          error={error}
          value={review}
        />
      </div>

      <TableReview getReviewByDel={(id) => getReviewByDel(id)} />

      <ModalDelete
        title="Delete"
        text="Are you sure you want to delete the comment?"
        toggle={toggleDel}
        close={closeBtnDel}
        isOpen={openDel}
        onClick={() => handleSubmitDel(dataDel.id)}
      />
    </div>
  );
}

export default Review;
